import { render, staticRenderFns } from "./clipboardPhotoUploaderConfirm.vue?vue&type=template&id=62b959c8&scoped=true&"
import script from "./clipboardPhotoUploaderConfirm.vue?vue&type=script&lang=js&"
export * from "./clipboardPhotoUploaderConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b959c8",
  null
  
)

export default component.exports